import {
  AUTHENTICATED_2FA_TIME,
  REQUESTED_2FA_TIME,
} from '../pages/TwoFactorAuth/constants'

export const keysToRemoveCacheSignout = [
  'user',
  'screening',
  'clinic',
  'zendesk-key',
  'embed',
  'patientData',
  'inactiveUser',
  'sendingType',
  'dependent',
  'your-health-srq20',
  'id-clinic',
  'unique-code',
  AUTHENTICATED_2FA_TIME,
  REQUESTED_2FA_TIME,
]
